import { render, staticRenderFns } from "./DryCowStrategy.vue?vue&type=template&id=2cb63514&"
import script from "./DryCowStrategy.vue?vue&type=script&lang=js&"
export * from "./DryCowStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports